import { t } from '@lingui/core/macro';
import { validPhoneRegex } from 'shared/validators/phone.validator';
import * as yup from 'yup';

/** Сообщения — функции: yup зовёт их в момент валидации, поэтому текст берётся на текущем языке. */
export const authSignUpValidator = () =>
  yup.object({
    firstName: yup.string().required(() => t`Имя обязательно`),
    lastName: yup.string().required(() => t`Фамилия обязательна`),
    middleName: yup.string().optional(),
    phone: yup
      .string()
      .required(() => t`Номер телефона обязателен`)
      .matches(validPhoneRegex, () => t`Введите корректный номер телефона`),
    sportType: yup
      .object({
        label: yup.string().required(),
        value: yup.string().required(() => t`Выберите вид спорта`),
      })
      // Пустой селект — `null`: без `nullable` yup падает на проверке типа с английским текстом
      // («must be a `object` type»), а не на `required`.
      .nullable()
      .required(() => t`Выберите вид спорта`) as yup.AnyObjectSchema,
    tournamentName: yup.string().required(() => t`Введите название турнира`),
  });
